<router-outlet></router-outlet>
<!-- 利用規約のバージョンが違う場合の同意フォーム-->
<div class="modal" *ngIf="showAgreementForm">
  <div class="modalOverlay"></div>
  <div class="modalContainer">
    <app-agreement-statuses></app-agreement-statuses>
  </div>
</div>
